exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageContent[data-v-89043b48] {\n  max-width: 764px;\n}\n.equipment-section[data-v-89043b48] {\n  padding: 4rem;\n}\n@media (max-width: 768px) {\n.equipment-section[data-v-89043b48] {\n      padding: 4rem 2rem;\n}\n}\n.productSectionTitle[data-v-89043b48] {\n  margin-bottom: 4rem;\n}\n", ""]);

// exports
